import "./es.object.assign-7e79fd7b.js";
import { QUERIES as $ } from "@ucl/shared-component-foundations";
import { useRef as W } from "react";
import s from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as w } from "./getMetrics-953aa4f8.js";
import { uniqueId as x } from "./uniqueId.js";
import { jsx as c } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
var u = function(i) {
  switch (i) {
    case 1:
    case 2:
    case 4:
    case 5:
    case 7:
    case 8:
    case 10:
    case 11:
      return 8.33 * i + "%";
    case 3:
      return "25%";
    case 6:
      return "50%";
    case 9:
      return "75%";
    default:
      return "100%";
  }
}, _ = /* @__PURE__ */ s.div.withConfig({
  displayName: "grid__MainWrapper",
  componentId: "sc-1nfaavh-0"
})(["", ";"], function(e) {
  var i, t, r;
  return `
    width: ` + (e == null || (i = e.theme) == null ? void 0 : i.components.grid.MainWrapper.width) + `;
    height: ` + (e == null || (t = e.theme) == null ? void 0 : t.components.grid.MainWrapper.height) + `;
    overflow: ` + (e == null || (r = e.theme) == null ? void 0 : r.components.grid.MainWrapper.overflow) + `;
  `;
}), I = /* @__PURE__ */ s.div.withConfig({
  displayName: "grid__GridWrapper",
  componentId: "sc-1nfaavh-1"
})(["", ""], function(e) {
  var i, t, r, n, d;
  return `
  width: calc(` + (e == null || (i = e.theme) == null ? void 0 : i.components.grid.GridWrapper.width) + " + " + e.$gutterWidth + `px);
  display: ` + (e == null || (t = e.theme) == null ? void 0 : t.components.grid.GridWrapper.display) + `;
  flex-wrap: ` + (e == null || (r = e.theme) == null ? void 0 : r.components.grid.GridWrapper.flexWrap) + `;
  height: ` + (e == null || (n = e.theme) == null ? void 0 : n.components.grid.GridWrapper.height) + `;
  box-sizing: ` + (e == null || (d = e.theme) == null ? void 0 : d.components.grid.GridWrapper.boxSizing) + `;
  --gutter-width: ` + e.$gutterWidth + `px;
  row-gap: ` + e.$rowGap + `px;
  `;
}), y = /* @__PURE__ */ s.div.withConfig({
  displayName: "grid__FlexGridWrapper",
  componentId: "sc-1nfaavh-2"
})(["", ""], function(e) {
  var i, t, r, n, d;
  return `
    width: ` + (e == null || (i = e.theme) == null ? void 0 : i.components.grid.FlexGridWrapper.width) + `;
    min-width: ` + (e == null || (t = e.theme) == null ? void 0 : t.components.grid.FlexGridWrapper.minWidth) + `;
    flex-grow: ` + (e == null || (r = e.theme) == null ? void 0 : r.components.grid.FlexGridWrapper.flexGrow) + `;
    height: ` + (e == null || (n = e.theme) == null ? void 0 : n.components.grid.FlexGridWrapper.height) + `;
    box-sizing: ` + (e == null || (d = e.theme) == null ? void 0 : d.components.grid.FlexGridWrapper.boxSizing) + `;
    padding-right: var(--gutter-width);
  `;
}), N = /* @__PURE__ */ s.div.withConfig({
  displayName: "grid__GridItemWrapper",
  componentId: "sc-1nfaavh-3"
})(["", ""], function(e) {
  var i, t;
  return `
    width: ` + u(e == null ? void 0 : e.$s) + `;
    height: ` + (e == null || (i = e.theme) == null ? void 0 : i.components.grid.GridItemWrapper.height) + `;
    box-sizing: ` + (e == null || (t = e.theme) == null ? void 0 : t.components.grid.GridItemWrapper.boxSizing) + `;
    padding-right: var(--gutter-width);

    @media ` + $.tabletAndUp + ` {
      width: ` + u(e.$m) + `;
    }
    @media ` + $.laptopAndUp + ` {
      width: ` + u(e.$l) + `;
    }
    @media ` + $.desktopAndUp + ` {
      width: ` + u(e.$xl) + `;
    }
  `;
}), f = function(i) {
  var t = i.children, r = i.gutterWidth, n = r === void 0 ? 12 : r, d = i.style, l = d === void 0 ? {} : d, m = i.className, o = m === void 0 ? "" : m, a = i.rowGap, g = a === void 0 ? 8 : a, p = w({
    label: "Grid"
  }), v = W(null), h = W(x("grid"));
  return /* @__PURE__ */ c(_, Object.assign({}, p, {
    children: /* @__PURE__ */ c(I, {
      id: h.current,
      ref: v,
      $gutterWidth: n,
      style: l,
      className: o,
      $rowGap: g,
      children: t
    })
  }));
}, F = function(i) {
  var t = i.s, r = t === void 0 ? 12 : t, n = i.m, d = n === void 0 ? 6 : n, l = i.l, m = l === void 0 ? 4 : l, o = i.xl, a = o === void 0 ? 3 : o, g = i.children, p = i.style, v = p === void 0 ? {} : p, h = i.className, G = h === void 0 ? "" : h;
  return /* @__PURE__ */ c(N, {
    $s: r,
    $m: d,
    $l: m,
    $xl: a,
    style: v,
    className: "grid-item " + G,
    children: g
  });
}, b = function(i) {
  var t = i.className, r = i.style, n = i.children;
  return /* @__PURE__ */ c(y, {
    className: "grid-item " + t,
    style: r,
    children: n
  });
};
f.Item = F;
f.FlexItem = b;
export {
  f as Grid
};
